// import React, { useEffect, useState } from "react";
// import Navbar from "../navbarv2/navbar";
// import Footer from "../navbarv2/footer";


// function Receipt() {
//   const [buyerName, setBuyerName] = useState(""); // ช่องกรอกชื่อผู้ซื้อ
//   const [order, setOrder] = useState(null);

//   // จำลองข้อมูลคำสั่งซื้อ (สามารถเปลี่ยนเป็น API จริงได้)
//   useEffect(() => {
//     const mockOrder = {
//       purchaseDate: new Date().toLocaleDateString("th-TH"), // วันที่ซื้อ
//       orderId: "ORD123456789",
//       items: [
//         { name: "XXXXXX", quantity: 2, price: 250 },
//         { name: "XXXXXX", quantity: 1, price: 590 },
//         { name: "XXXXXX", quantity: 1, price: 990 },
//       ],
//     };
//     setOrder(mockOrder);
//   }, []);

//   // คำนวณยอดรวม
//   const getTotalPrice = () => {
//     return order?.items.reduce((total, item) => total + item.price * item.quantity, 0) || 0;
//   };

//   // ฟังก์ชันบันทึกข้อมูล
//   const handleSave = () => {
//     if (buyerName.trim() === "") {
//       alert("กรุณากรอกชื่อผู้ซื้อก่อนบันทึกข้อมูล!");
//       return;
//     }
//     alert(`บันทึกใบเสร็จสำหรับ: ${buyerName}\nรวมเป็นเงิน: ${getTotalPrice().toLocaleString()} บาท`);
//   };

//   // ฟังก์ชันยกเลิก (ล้างข้อมูล)
//   const handleCancel = () => {
//     setBuyerName("");
//     setOrder(null);
//   };

//   return (
//     <div>
//       <Navbar />
//       <div className="container mt-5">
//         <div className="card shadow-lg p-4">
//           <h2 className="text-center mb-4">🧾 แจ้งขอใบเสร็จรับเงิน</h2>

//           {order ? (
//             <div>
//               <div className="mb-3">
//                 <label className="form-label"><strong>ออกในนาม:</strong></label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="กรอกข้อมูล"
//                   value={buyerName}
//                   onChange={(e) => setBuyerName(e.target.value)}
//                 />
//               </div>

//               <p><strong>วันที่ซื้อ:</strong> {order.purchaseDate}</p>
//               <p><strong>เลขที่คำสั่งซื้อ:</strong> {order.orderId}</p>
//               <p><strong>สวนสัตว์:</strong>สวนสัตว์เปิดขาเขียว</p>

//               <h4 className="mt-4">📌 รายการที่ซื้อทั้งหมด</h4>
//               <table className="table table-striped mt-2">
//                 <thead className="table-dark">
//                   <tr>
//                     <th>#</th>
//                     <th>รายการ</th>
//                     <th>จำนวน</th>
//                     <th>ราคา (บาท)</th>
//                     <th>รวม (บาท)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {order.items.map((item, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>{item.name}</td>
//                       <td>{item.quantity}</td>
//                       <td>{item.price.toLocaleString()}</td>
//                       <td>{(item.price * item.quantity).toLocaleString()}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>

//               <h4 className="text-end mt-3">💰 รวมเป็นเงิน: {getTotalPrice().toLocaleString()} บาท</h4>

//               {/* ปุ่มบันทึก & ยกเลิก */}
//               <div className="d-flex justify-content-between mt-4">
//                 <button className="btn btn-success px-4" onClick={handleSave}>✅ บันทึกข้อมูล</button>
//                 <button className="btn btn-danger px-4" onClick={handleCancel}>❌ ยกเลิก</button>
//               </div>
//             </div>
//           ) : (
//             <p className="text-center text-danger">⏳ กำลังโหลดข้อมูล...</p>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default Receipt;


import React, { useEffect, useState } from "react";
import Navbar from "../navbarv2/navbar";
import Footer from "../navbarv2/footer";

function Receipt() {
  const [buyerName, setBuyerName] = useState("");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const mockOrder = {
      purchaseDate: new Date().toLocaleDateString("th-TH"),
      orderId: "ORD123456789",
      items: [
        { name: "บัตรเข้าชมสวนสัตว์", quantity: 2, price: 250 },
        { name: "แพ็คเกจอาหารสัตว์", quantity: 1, price: 590 },
        { name: "ของที่ระลึก", quantity: 1, price: 990 },
      ],
    };
    setOrder(mockOrder);
  }, []);

  const getTotalPrice = () => {
    return order?.items.reduce((total, item) => total + item.price * item.quantity, 0) || 0;
  };

  const handleSave = () => {
    if (buyerName.trim() === "") {
      alert("กรุณากรอกชื่อผู้ซื้อก่อนบันทึกข้อมูล!");
      return;
    }
    alert(`บันทึกใบเสร็จสำหรับ: ${buyerName}\nรวมเป็นเงิน: ${getTotalPrice().toLocaleString()} บาท`);
  };

  const handleCancel = () => {
    setBuyerName("");
    setOrder(null);
  };

  return (
    <div className="bg-light min-vh-100">
      <Navbar />
      <div className="container py-5">
        <div className="card shadow-lg p-4 rounded-4 border-0">
          <h2 className="text-center mb-4 fw-bold text-primary">🧾 แจ้งขอใบเสร็จรับเงิน</h2>

          {order ? (
            <div>
              <div className="mb-3">
                <label className="form-label fw-semibold">ออกในนาม:</label>
                <input
                  type="text"
                  className="form-control border-primary shadow-sm"
                  placeholder="กรอกรายละเอียดข้อมูล"
                  value={buyerName}
                  onChange={(e) => setBuyerName(e.target.value)}
                />
              </div>

              <div className="bg-light p-3 rounded-3 shadow-sm">
                <p className="mb-2"><strong>📅 วันที่ซื้อ:</strong> {order.purchaseDate}</p>
                <p className="mb-2"><strong>🛒 เลขที่คำสั่งซื้อ:</strong> {order.orderId}</p>
                <p className="mb-2"><strong>🐘 สวนสัตว์:</strong> สวนสัตว์เปิดเขาเขียว</p>
              </div>

              <h4 className="mt-4 text-success fw-bold">📌 รายการที่ซื้อทั้งหมด</h4>
              <table className="table table-striped mt-2 border rounded-3 overflow-hidden">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>รายการ</th>
                    <th>จำนวน</th>
                    <th>ราคา (บาท)</th>
                    <th>รวม (บาท)</th>
                  </tr>
                </thead>
                <tbody>
                  {order.items.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.quantity}</td>
                      <td>{item.price.toLocaleString()}</td>
                      <td>{(item.price * item.quantity).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <h4 className="text-end mt-3 text-danger fw-bold">💰 รวมเป็นเงิน: {getTotalPrice().toLocaleString()} บาท</h4>

              <div className="d-flex justify-content-between mt-4">
                <button className="btn btn-success px-4 py-2 fw-bold shadow-sm" onClick={handleSave}>✅ บันทึกข้อมูล</button>
                <button className="btn btn-danger px-4 py-2 fw-bold shadow-sm" onClick={handleCancel}>❌ ยกเลิก</button>
              </div>
            </div>
          ) : (
            <p className="text-center text-danger fw-bold">⏳ กำลังโหลดข้อมูล...</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Receipt;